__turbopack_context__.v({
  "block": "ContrastInfoBlock-module-scss-module__K3z7NG__block",
  "section": "ContrastInfoBlock-module-scss-module__K3z7NG__section",
  "subtitle": "ContrastInfoBlock-module-scss-module__K3z7NG__subtitle",
  "title": "ContrastInfoBlock-module-scss-module__K3z7NG__title",
});
